<template>
  <aside class="sidepanel" :class="sideShow ? 'sidepanel0':''">
    <div class="card-box card-box-bottom">
      <el-input
        placeholder="姓名/机器码"
        v-model.trim="keyword">
        <i class="el-icon-search" slot="suffix" @click="queryCarList" />
      </el-input>
      <el-scrollbar v-if="$can('car.view.all')">
        <div v-show="selectList.length > 0">
          <ul class="selectList">
            <li v-for="item in selectList" @click="atQueryUser(item.SN,item.CarName,item.Lat,item.Lon)"><i :class="item.OnlineStatu == 0?'offline':'online'" class="iconfont icon-dian"></i> {{item.CarName}}</li>
          </ul>
        </div>
        <el-tree v-show="selectList.length == 0"
          :props="props"
          :load="loadNode"
          lazy
          node-key="belongId"
          @node-click="getNodeData">
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <i v-if="data.SN" :class="data.state == 0?'offline':'online'" class="iconfont icon-dian"></i>
            {{node.label}}
          </span>
        </el-tree>
      </el-scrollbar>
      <el-scrollbar v-else>
        <div v-show="selectList.length > 0">
          <ul class="selectList">
            <li v-for="item in selectList" @click="atQueryUser(item.SN,item.CarName,item.Lat,item.Lon)"><i :class="item.OnlineStatu == 0?'offline':'online'" class="iconfont icon-dian"></i> {{item.CarName}}</li>
          </ul>
        </div>
       <div v-show="selectList.length == 0">
          <ul class="selectList">
            <li v-for="item in dataList" @click="atQueryUser(item.SN,item.label,item.Lat,item.Lon)"><i :class="item.state == 0?'offline':'online'" class="iconfont icon-dian"></i> {{item.label}}</li>
          </ul>
        </div>
        <!-- <el-tree v-show="selectList.length == 0"
          :props="props"
          :load="loadNode"
          lazy
          node-key="belongId"
          @node-click="getNodeData">
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <i v-if="data.SN" :class="data.state == 0?'offline':'online'" class="iconfont icon-dian"></i>
            {{node.label}}
          </span>
        </el-tree> -->
      </el-scrollbar>
      <div class="sideShow" @click="sidepanel"><i :class="sideShow ? 'el-icon-arrow-right':'el-icon-arrow-left'"></i></div>
    </div>
  </aside>
</template>
<script>
  import { getBelong,queryCar,getUserAccount,getUserCarList } from "@/utils/api.js";
  export default {
    name:'carTree',
    data(){
      return{
        keyword:'',
        sideShow:true,
        props: {
          label: 'label',
          children: [],
          isLeaf: 'leaf',
          state: 'state',
        },
        selectList:[],
        dataList:[]
      };
    },
    mounted() {
      //非全量视图只拉自己的桩机列表,全量视图走懒加载树
      if(!this.$can('car.view.all')){
        getBelong().then(response => {
          if(response){
            this.dataList = response.data
          }
        })
        // getUserCarList({id:node.data.id}).then(response => {
        //   if(response){
        //     response.data.forEach(item=>{
        //       item.leaf = true
        //     })
        //     return resolve(response.data)
        //   }
        // })
      }
    },
    watch:{
      keyword(){
        if(this.keyword == ''){
          this.selectList = []
        }
      }
    },
    methods:{
      sidepanel(){
        this.sideShow = !this.sideShow
      },
      loadNode(node, resolve) {
        console.log(node)
        if (node.level == 0) {
          getBelong().then(response => {
            if(response){
              return resolve(response.data);
            }
          })
        }
        if(node.level == 1){
          getUserAccount({belongId:node.data.id}).then(response => {
            if(response){
              return resolve(response.data)
            }
          })
          // return resolve(node.data.children);
        }
        if(node.level == 2){
          getUserCarList({id:node.data.id}).then(response => {
            if(response){
              response.data.forEach(item=>{
                item.leaf = true
              })
              return resolve(response.data)
            }
          })
        }
        if(node.level == 3){

        }
        // if (node.level > 2) return resolve([]);

      },
      getNodeData(e){
        if(e.leaf){
          this.isPath(e.SN,e.label,e.Lat,e.Lon)
        }
      },
      //获取行政列表
      getBelong(){
        getBelong().then(response => {
          if(response){
            this.belongList = response.data
          }
        })
      },
      //车辆搜索
      queryCarList(){
        let keyword = this.keyword
        if(keyword){
          queryCar({'val':keyword}).then(response => {
            if(response && response.data.length == 0){
              this.$message.error('未查询到该桩机！')
            }else{
              this.selectList = response.data
            }
          })
        }
      },
      //车辆搜索选中
      atQueryUser(SN,label,Lat,Lon){
        this.isPath(SN,label,Lat,Lon)
      },
      //判断path
      isPath(SN,label,Lat,Lon){
        let path = this.$route.path
        if(path == '/monitor'){
          this.$bus.emit('userLocal',{coord:[Lon,Lat],sn:SN})
          //this.$parent.$children[1].$refs.mapL.userLocal(,SN)
          //this.$parent.$children[1].getTodayWorkBySn(SN)
        }
        if(path == '/uploadWork'){
          this.$bus.emit('uploadWork',{name:label,sn:SN})
        }
        if(path == '/workAnalysis'){
          this.$bus.emit('workAnalysis',{name:label,sn:SN})
        }
        if(path == '/compareAnalysis'){
          this.$bus.emit('compareAnalysis',{name:label,sn:SN})
        }
        if(path == '/workStatistics'){
          this.$bus.emit('workStatistics',{name:label,sn:SN})
        }
      }
    }
  }
</script>

<style>
  .el-input__suffix i{
    display: flex;
    justify-content: center;
    align-items: center;
    cursor:pointer;
    width: 30px;
    height: 40px;
  }
  .el-tree{
    margin: 8px 0;
    height: calc(100% - 45px);
  }
  .online{
    color: #2AB437;
  }
 /* .custom-tree-node .job{
    color: #FFC746;
  } */
  .offline{
    color: #DA4D49;
  }
  .sideShow{
    position: absolute;
    z-index: 1002;
    top: 50%;
    transform: translate(0, -50px);
    right: -18px;
    width: 18px;
    background-color:#e8e8e8;
    height: 48px;
    line-height: 50px;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
    cursor: pointer;
  }
  .sideShow i{
    font-size: 1.3rem;
  }
  .selectList{
    padding:6px 1px;
  }
  .selectList li{
    height:32px;
    line-height:32px;
  }
  .selectList li:hover,.selectList li:active{
    background-color: #F5F7FA;
  }
</style>



// WEBPACK FOOTER //
// src/components/sidebar/index.vue